export default [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <div className="-mt-1.5 text-red-700">
          <strong> Start</strong>
        </div>
      ),
    },
    position: { x: 45, y: -17 },
    style: {
      background: "white",
      color: "#333",
      border: "1px solid red",
      fontSize: 8,
      width: 60,
      height: 10,
    },
  },
  {
    id: "2",
    data: { label: <div className="-mt-1.5 text-blue-200 font-semibold">Step 2</div> },
    position: { x: 20, y: 50 },
    style: {
      background: "white",
      color: "#333",
      border: "1px solid #1F78B4",
      fontSize: 8,
      width: 60,
      height: 10,
    },
  },
  {
    id: "3",
    data: { label: <div className="-mt-1.5 text-blue-200 font-semibold">Step 3</div> },
    position: { x: 100, y: 50 },
    style: {
      background: "white",
      color: "#333",
      border: "1px solid #1F78B4",
      fontSize: 8,
      width: 60,
      height: 10,
    },
  },
  {
    id: "4",
    data: { label: <div className="-mt-1.5 text-blue-200 font-semibold">Step 4</div> },
    position: { x: 100, y: 110 },
    style: {
      background: "white",
      color: "#333",
      border: "1px solid #1F78B4",
      fontSize: 8,
      width: 60,
      height: 10,
    },
  },
  {
    id: "5",
    data: {
      label: (
        <div className="-mt-1.5 text-red-700 ">
          <strong> End</strong>
        </div>
      ),
    },
    position: { x: 100, y: 160 },
    style: {
      background: "white",
      color: "#333",
      border: "1px solid red",
      fontSize: 8,
      width: 60,
      height: 10,
    },
  },

  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "20",
    labelStyle: { fill: "#1F78B4" },
    style: { stroke: "#1F78B4" },
  },
  { id: "e1-3", source: "1", target: "3", style: { stroke: "#1F78B4" } },
  {
    id: "e1-4",
    source: "3",
    target: "4",
    // label: "20",
    labelStyle: { fill: "#1F78B4" },
    style: { stroke: "#1F78B4" },
  },
  { id: "e1-5", source: "4", target: "5", style: { stroke: "#1F78B4" } },
];
